// extracted by mini-css-extract-plugin
export default {"container":"kY-z","title":"lY-z","link":"mY-z"};